var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.r.label)+" "),_c('van-radio-group',{model:{value:(_vm.r.value),callback:function ($$v) {_vm.$set(_vm.r, "value", $$v)},expression:"r.value"}},[_c('van-row',_vm._l((_vm.cols),function(n){return _c('van-col',{key:n},[_c('van-radio',{key:n,attrs:{"name":n}},[_vm._v(" "+_vm._s(n)+" ")])],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }